import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, list_type, string_type, class_type, union_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Filter_$reflection } from "../../../Kundenportal.Types.fs.js";
import { File_FileListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor(page, filter) {
        super();
        this.tag = 0;
        this.fields = [page, filter];
    }
    cases() {
        return ["Files"];
    }
}

export function Page_$reflection() {
    return union_type("Files.Types.Page", [], Page, () => [[["page", int32_type], ["filter", Filter_$reflection()]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadFiles", "FilesLoaded", "LoadKategorien", "KategorienLoaded", "ToggleBeschreibung", "MarkRead", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Files.Types.Msg", [], Msg, () => [[["page", int32_type], ["filter", Filter_$reflection()]], [["filter", Filter_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(File_FileListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(File_FileListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(PageNumber, SelectedFilter, Kategorien, Files, ExpandedBeschreibungen) {
        super();
        this.PageNumber = PageNumber;
        this.SelectedFilter = SelectedFilter;
        this.Kategorien = Kategorien;
        this.Files = Files;
        this.ExpandedBeschreibungen = ExpandedBeschreibungen;
    }
}

export function Model_$reflection() {
    return record_type("Files.Types.Model", [], Model, () => [["PageNumber", option_type(int32_type)], ["SelectedFilter", Filter_$reflection()], ["Kategorien", Remote$1_$reflection(list_type(string_type))], ["Files", Remote$1_$reflection(Paginated$1_$reflection(File_FileListItem_$reflection()))], ["ExpandedBeschreibungen", list_type(class_type("System.Guid"))]]);
}

//# sourceMappingURL=Types.fs.js.map
